"use client"

import { useRef } from "react"
import { useWindowEvent } from "src/hooks/useWindowEvent"

export function useArrowKeys<T extends HTMLElement>(callback: (change: -1 | 1) => void) {
  const ref = useRef<T>(null)

  useWindowEvent(
    "keydown",
    (event) => {
      if (!ref.current?.contains(event.target as Node)) {
        return
      }

      if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
        callback(-1)
      } else if (event.key === "ArrowRight" || event.key === "ArrowDown") {
        callback(1)
      } else if (event.key === " ") {
        event.preventDefault()
      }
    },
    { capture: true, passive: true },
  )

  return ref
}
